<template>
  <div class="jlxk-data-content">
    <condition
      ref="conditon"
      :is-show-status="isShowStatus"
      :is-un-limit-department="false"
      @updateExpand="updateExpand"
      @handleSearch="handleSearch"
    />
    <div class="condition">
      <el-checkbox
        :indeterminate="isIndeterminate"
        v-model="checkAll"
        class="check-all"
        @change="handleCheckAllChange"
      >
        全选
      </el-checkbox>
      <router-link :to="uploadURL">
        上传
      </router-link>
      <el-button
        v-for="(item,index) in btnArr"
        :key="index"
        v-show="handleShow(item)"
        @click="handleCommand(item.id)"
      >
        {{ item.label }}
      </el-button>
    </div>
    <List
      ref="list"
      :list-data="listData"
      :empty="empty"
      :checked-data="checkedLists"
      :is-show-checked="true"
      :is-show-status="true"
      @handleCheckedListsChange="handleCheckedListsChange"
      @changeSelected="changeSelected"
    />
    <el-pagination
      v-show="listData.length !== 0"
      background
      :page-size="pageSize"
      layout="slot, prev, pager, next"
      :total="total"
      :current-page="page"
      @current-change="handleCurrentChange"
    >
      <span class="total">
        共
        <em>{{ total }}</em>条信息
      </span>
    </el-pagination>
  </div>
</template>

<script>
import { containCount, arrReduce, isContained, unRelition } from '@common/util.js'
import condition from '@views/jlxk/review/components/condition'
import List from '@views/jlxk/dataView/components/list'
export default {
  name: 'JlxkContent',
  props: {
    listData: {
      type: Array,
      default: () => []
    },
    totalData: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    },
    empty: {
      type: String,
      default: ''
    },
    isShowStatus: {
      type: Boolean,
      default: false
    },
    uploadURL: {
      type: Object,
      default: () => {}
    },
    btnArr: {
      type: Array,
      default: () => []
    }
  },
  components: {
    condition,
    List
  },
  data() {
    return {
      isIndeterminate: false,
      checkAll: false,
      checkedLists: [],
      page: 1,
      pageSize: 20
    }
  },
  computed: {
    dataArr() {
      return this.listData.map(item => item.id)
    },
    isCanOperate() {
      return this.checkedLists.length !== 0
    },
    selectedData() {
      return this.totalData.filter(
        item => this.checkedLists.indexOf(item.id) !== -1
      )
    }
  },
  created() {},
  mounted() {},
  methods: {
    resetCheck() {
      this.page = 1
      this.checkedLists = []
      this.checkAll = false
      this.isIndeterminate = false
      this.$refs.list.checkedLists = []
    },
    initParams() {
      this.resetCheck()
      this.$refs.conditon.initParams()
    },
    getParams() {
      return Object.assign({}, this.$refs.conditon.conditonParams, {
        page: this.page,
        pagesize: this.pageSize
      })
    },
    // 列表查询
    handleSearch() {
      this.page = 1
      this.$emit('updateList')
    },
    // 页码切换
    handleCurrentChange(val) {
      this.page = val
      this.$emit('updateList')
    },
    handleCheckedChange() {
      this.isIndeterminate = !isContained(this.checkedLists, this.dataArr) && !unRelition(this.checkedLists, this.dataArr)
      this.checkAll = isContained(this.checkedLists, this.dataArr)
    },
    changeSelected(index) {
      this.$emit('changeSelected', index)
    },
    //  全选切换
    handleCheckAllChange(val) {
      this.isIndeterminate = false
      val
        ? (this.checkedLists = Array.from(
          new Set([...this.checkedLists, ...this.dataArr])
        ))
        : (this.checkedLists = arrReduce(this.checkedLists, this.dataArr))
    },
    handleCheckedListsChange(val) {
      this.checkedLists = [...val]
      let checkedCount = containCount(val, this.dataArr)
      this.checkAll = checkedCount === this.listData.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.listData.length
    },
    updateExpand(val) {
      this.$emit('updateExpand', val)
    },
    handleCommand(val) {
      this.$emit('handleCommand', { flag: val, isDetail: false })
    },
    // 操作行展示条件
    handleShow(value) {
      if (!this.isCanOperate) return false
      if (value.id === 'delete') return true
      let flag = true
      this.selectedData.forEach(item => {
        if (item.status !== 4) {
          flag = false
          return false
        }
      })
      return flag
    }
  }
}
</script>

<style lang="scss" scoped>
.jlxk-data-content {
  display: flex;
  flex-direction: column;
  width: 616px;
  margin: 0 12px 0 152px;
  height: calc(100vh - 100px);
  @extend .comBackground;
  .condition {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    position: relative;
    height: 48px;
    background: #edf0f7;
    padding-left: 25px;
    &::before {
      position: absolute;
      left: 0;
      top: 17px;
      content: "";
      width: 4px;
      height: 15px;
      background: rgba(234, 85, 33, 1);
      border-radius: 2px;
    }
    // /deep/ .check-all {
    //   .el-checkbox__label {
    //     padding-left: 9px;
    //   }
    // }
    a,
    .el-button {
      display: inline-flex;
      align-items: center;
      margin-left: 17px;
      justify-content: center;
      height: 30px;
      padding: 0 16px;
      background: #f4f7fa;
      border: 1px solid #0499f3;
      border-radius: 5px;
      text-decoration: none;
      font-size: 13px;
      color: #0499f3;
    }
    .el-button {
      margin-left: 8px;
      padding: 0 13px;
    }
  }
  /deep/ .list {
    flex: 1;
    overflow-y: auto;
  }
  /deep/ .el-pagination {
    margin: 10px 0;
    padding: 0;
    text-align: center;
    .el-pager {
      li {
        background-color: #fff !important;
      }
      li.active {
        color: #4497ec;
      }
    }
    .btn-prev,
    .btn-next {
      background-color: #ffffff;
    }
    .total {
      color: #666666;
      font-weight: normal;
      margin-right: 18px;
      em {
        color: #4497ec;
        font-style: normal;
        padding: 0 3px;
      }
    }
  }
}
</style>
